/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { ActionHistory } from '@trello/action-history';
import { Analytics } from '@trello/atlassian-analytics';
import { getApiError, parseXHRError } from '@trello/error-handling';
import { sendNetworkErrorEvent } from '@trello/error-reporting';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { Auth } from 'app/scripts/db/Auth';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { isOverLimit } from 'app/scripts/lib/limits';
import { l } from 'app/scripts/lib/localize';
import { ApiAjax } from 'app/scripts/network/ApiAjax';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { SelectCardPosition } from 'app/scripts/views/card/SelectCardPosition';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { LabelLimitsErrorView } from 'app/scripts/views/label/LabelLimitsErrorView';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverMoveCardTemplate } from 'app/scripts/views/templates/PopoverMoveCardTemplate';
import { isBoardControllerRefactorEnabled } from 'app/src/components/Board/isBoardControllerRefactorEnabled';
import { returnToBoard } from 'app/src/components/Board/returnToBoard';

const MAX_SUGGESTIONS = 5;

const tooManyCustomFieldsError = 'BOARD_TOO_MANY_CUSTOM_FIELDS';
const tooManyCustomFieldOptionsError = 'CUSTOM_FIELD_TOO_MANY_OPTIONS';

interface CardMoveView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCommit: any;
}

class CardMoveView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'move card';

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'change .js-select-position': string; 'cha... Remove this comment to see the full error message
      'change .js-select-position': 'renderValues',
      'change .js-select-list': 'updatePositionList',
      'change .js-select-board': 'updateBoardData',
      'click .js-submit': 'commitChange',
      'click .js-suggested-move': 'suggestedMove',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ onCommit }: any) {
    this.onCommit = onCommit != null ? onCommit : function () {};
    Analytics.sendScreenEvent({
      name: 'moveCardInlineDialog',
      containers: this.model.getAnalyticsContainers(),
      attributes: {
        cardIsTemplate: this.model.get('isTemplate'),
        cardIsClosed: this.model.get('closed'),
      },
    });
    return this.listenTo(Auth.me().boardList, 'add remove reset', this.render);
  }

  render() {
    const data = {};
    let currentBoard = this.model.getBoard();
    const enterprise = this.model.getBoard().getEnterprise();

    // Don't allow guests on enterprise owned boards to move cards off the current board
    const isGuest = currentBoard.isGuest(Auth.me());

    // check if the enterprise member is of the same enterprise as the board, they can move lists
    const isEnterpriseMember =
      enterprise != null &&
      Auth.me().isManagedEntMemberOf(enterprise.get('id'));

    if (isGuest && currentBoard.get('enterpriseOwned') && !isEnterpriseMember) {
      // @ts-expect-error TS(2339): Property 'isMove' does not exist on type '{}'.
      data.isMove = true;
      // @ts-expect-error TS(2339): Property 'hasEnterprise' does not exist on type '{... Remove this comment to see the full error message
      data.hasEnterprise = true;
      // @ts-expect-error TS(2339): Property 'enterpriseName' does not exist on type '... Remove this comment to see the full error message
      data.enterpriseName =
        enterprise != null ? enterprise.get('displayName') : undefined;
      // @ts-expect-error TS(2339): Property 'restrictToCurrentBoard' does not exist o... Remove this comment to see the full error message
      data.restrictToCurrentBoard = true;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = [
        {
          displayName:
            currentBoard.getOrganization()?.get('displayName') ||
            l('member boards.boards'),
          boards: [{ ...currentBoard.toJSON(), selected: true }],
        },
      ];
    } else if (enterprise != null) {
      // @ts-expect-error TS(2339): Property 'isMove' does not exist on type '{}'.
      data.isMove = true;
      // @ts-expect-error TS(2339): Property 'hasEnterprise' does not exist on type '{... Remove this comment to see the full error message
      data.hasEnterprise = true;
      currentBoard =
        this.model.getBoard().getMembershipFor(Auth.me()) == null
          ? currentBoard
          : null;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(
        true,
        enterprise.get('id'),
        currentBoard,
      );
      // @ts-expect-error TS(2339): Property 'enterpriseName' does not exist on type '... Remove this comment to see the full error message
      data.enterpriseName = enterprise.get('displayName');
    } else {
      currentBoard = this.model
        .getBoard()
        .isEditableByTeamMemberAndIsNotABoardMember()
        ? currentBoard
        : null;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard);
    }

    // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
    for (const org of Array.from(data.organizations)) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      for (const board of Array.from(org.boards)) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (board.id === this.model.get('idBoard')) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          board.selected = true;
          currentBoard = board;
        }
      }
    }

    // @ts-expect-error TS(2339): Property 'suggestions' does not exist on type '{}'... Remove this comment to see the full error message
    data.suggestions = this.getSuggestedMoves();

    // @ts-expect-error TS(2339): Property 'move_card_controls' does not exist on ty... Remove this comment to see the full error message
    let partials = { move_card_controls: templates.move_card_controls };

    // @ts-expect-error TS(2339): Property 'move_card_controls' does not exist on ty... Remove this comment to see the full error message
    partials = { move_card_controls: templates.move_card_controls };

    this.$el.html(templates.fill(PopoverMoveCardTemplate, data, {}, partials));

    this.updateBoardData();

    // @ts-expect-error TS(2339): Property 'suggestions' does not exist on type '{}'... Remove this comment to see the full error message
    if (data.suggestions.length > 0) {
      Analytics.sendViewedComponentEvent({
        componentType: 'section',
        // @ts-expect-error TS(2322): Type '"moveCardSuggestionSection"' is not assignab... Remove this comment to see the full error message
        componentName: 'moveCardSuggestionSection',
        // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
        source: this.options?.source || 'moveCardInlineDialog',
        containers: this.model?.getAnalyticsContainers(),
        attributes: {
          // @ts-expect-error TS(2339): Property 'suggestions' does not exist on type '{}'... Remove this comment to see the full error message
          suggestionCount: data.suggestions.length,
        },
      });
    }

    return this;
  }

  getSuggestedMoves() {
    const history = ActionHistory.get();

    const board = this.model.getBoard();
    const list = this.model.getList();
    const idList = this.model.get('idList');
    const idBoard = this.model.get('idBoard');

    const suggested = new Set();

    return history
      .filter(
        ({ action, context }) =>
          action.type === 'move' &&
          // Only move to places we've moved to from this list
          context.idList === idList &&
          // For now, restrict this to moves to other lists on the same board
          action.idBoard === idBoard,
      )
      .sort(function (a, b) {
        // For two moves to the same target list,
        // prefer moves with an unambiguous target position, aka 'top' or 'bottom'
        // @ts-expect-error TS(2339): Property 'idList' does not exist on type 'HistoryA... Remove this comment to see the full error message
        if (a.action.idList === b.action.idList) {
          // @ts-expect-error TS(2339): Property 'position' does not exist on type 'Histor... Remove this comment to see the full error message
          const aHasPosition = typeof a.action.position === 'string';
          // @ts-expect-error TS(2339): Property 'position' does not exist on type 'Histor... Remove this comment to see the full error message
          const bHasPosition = typeof b.action.position === 'string';
          if (aHasPosition && !bHasPosition) {
            return -1;
          } else if (bHasPosition && !aHasPosition) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      })
      .filter(function ({ action }) {
        // @ts-expect-error TS(2339): Property 'idList' does not exist on type 'HistoryA... Remove this comment to see the full error message
        if (suggested.has(action.idList)) {
          return false;
        } else {
          // @ts-expect-error TS(2339): Property 'idList' does not exist on type 'HistoryA... Remove this comment to see the full error message
          suggested.add(action.idList);
          return true;
        }
      })
      .filter(({ action }) => this.model.isValidSuggestion(action))
      .slice(0, MAX_SUGGESTIONS)
      .map(function ({ action }) {
        // @ts-expect-error TS(2339): Property 'idList' does not exist on type 'HistoryA... Remove this comment to see the full error message
        const targetList = board.listList.get(action.idList);
        const data = targetList.toJSON();
        data.direction =
          targetList.get('pos') > list.get('pos') ? 'right' : 'left';
        // @ts-expect-error TS(2339): Property 'position' does not exist on type 'Histor... Remove this comment to see the full error message
        data.position = action.position;
        return data;
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  suggestedMove(e: any) {
    const $target = $(e.currentTarget, this.$el);

    const idList = $target.attr('data-id');
    const listSelected = this.model.getBoard().listList.get(idList);
    const indexSelected = (() => {
      switch ($target.attr('data-position')) {
        case 'top':
          return 0;
        case '1':
          return 1;
        default:
          return listSelected.cardList.length;
      }
    })();

    const options = {
      $elem: $target,
      destinationList: listSelected,
    };

    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    this.model.moveToList(
      listSelected,
      indexSelected,
      false,
      this.options?.source,
    );
    Analytics.sendTrackEvent({
      action: 'moved',
      actionSubject: 'card',
      // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
      source: this.options?.source || 'moveCardInlineDialog',
      attributes: {
        sameBoard: true,
        suggested: true,
      },
      containers: this.model?.getAnalyticsContainers(),
    });

    this.onCommit();

    PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commitChange(e: any) {
    let traceId;

    const $selectBoard = $('.js-select-board', this.$el);
    const idBoardSelected = $selectBoard.find('option:selected').val();

    if (idBoardSelected !== this.model.getBoard().id) {
      traceId = Analytics.startTask({
        taskName: 'edit-card/idBoard',
        // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
        source: this.options?.source || 'moveCardInlineDialog',
      });
    }

    const $selectList = $('.js-select-list', this.$el);

    const $selectPos = $('.js-select-position', this.$el);

    const idListSelected = $selectList.find('option:selected').val();
    const posSelected = $selectPos.find('option:selected').val();
    const indexSelected = parseInt(
      $selectPos.find('option:selected').prop('index'),
      10,
    );

    return this.requestChange(
      e,
      idBoardSelected,
      idListSelected,
      posSelected,
      indexSelected,
      traceId,
    );
  }

  requestChange(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idBoardSelected: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idListSelected: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    posSelected: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    indexSelected: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    traceId: any,
  ) {
    let listSelected, options;

    if (idBoardSelected === this.model.getBoard().id) {
      listSelected = this.model.getBoard().listList.get(idListSelected);
      options = {
        $elem: $(e.target, this.$el),
        destinationList: listSelected,
      };
      if (maybeDisplayLimitsErrorOnCardAdd(options)) {
        return;
      }

      this.model.moveToList(
        listSelected,
        indexSelected,
        false,
        this.options?.source,
      );
      Analytics.sendTrackEvent({
        action: 'moved',
        actionSubject: 'card',
        // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
        source: this.options?.source || 'moveCardInlineDialog',
        attributes: {
          sameBoard: true,
          suggested: false,
        },
        containers: this.model?.getAnalyticsContainers(),
      });
    } else if (
      idBoardSelected != null &&
      idListSelected != null &&
      posSelected != null
    ) {
      const boardSelected = ModelCache.get('Board', idBoardSelected);
      listSelected =
        boardSelected != null
          ? boardSelected.listList.get(idListSelected)
          : undefined;
      options = {
        $elem: $(e.target, this.$el),
        hasChecklists: this.model.checklistList.length > 0,
        hasAttachments: this.model.attachmentList.length > 0,
        destinationBoard: boardSelected,
        destinationList: listSelected,
      };
      if (maybeDisplayLimitsErrorOnCardAdd(options)) {
        Analytics.taskFailed({
          taskName: 'edit-card/idBoard',
          // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
          source: this.options?.source || 'moveCardInlineDialog',
          traceId,
          error: new Error('Exceeded a card limit'),
        });
        return;
      }
      const hasLabels = this.model.getLabels().length > 0;
      if (
        hasLabels &&
        // @ts-expect-error
        isOverLimit('labels', 'perBoard', boardSelected.get('limits'))
      ) {
        Analytics.taskFailed({
          taskName: 'edit-card/idBoard',
          // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
          source: this.options?.source || 'moveCardInlineDialog',
          traceId,
          error: new Error('Exceeded label limit per board'),
        });
        PopOver.pushView(new LabelLimitsErrorView());
        return;
      }

      Analytics.sendTrackEvent({
        action: 'moved',
        actionSubject: 'card',
        // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
        source: this.options?.source || 'moveCardInlineDialog',
        attributes: {
          sameBoard: false,
          suggested: false,
        },
        containers: this.model?.getAnalyticsContainers(),
      });

      const cardsInSelectedList =
        listSelected != null ? listSelected.openCards().length : 0;
      this.model.recordAction({
        type: 'move',
        idBoard: idBoardSelected,
        idList: idListSelected,
        position: (() => {
          switch (posSelected) {
            case 'top':
              if (cardsInSelectedList > 0) {
                return 'top';
              } else {
                return indexSelected;
              }
            case 'bottom':
              if (cardsInSelectedList > 1) {
                return 'bottom';
              } else {
                return indexSelected;
              }
            default:
              return indexSelected;
          }
        })(),
        fromPosition: this.model.getList().openCards().indexOf(this.model),
      });

      this.model.getList().cardList.remove(this.model);
      if (isBoardControllerRefactorEnabled()) {
        returnToBoard();
      } else {
        // If we're showing a dialog (card detail) then hide it
        Dialog.hide();
      }

      ApiAjax({
        url: `/1/cards/${this.model.id}`,
        type: 'put',
        data: {
          idList: idListSelected,
          idBoard: idBoardSelected,
          pos: posSelected,
        },
        traceId,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        success: (data: any) => {
          Analytics.taskSucceeded({
            traceId,
            taskName: 'edit-card/idBoard',
            // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
            source: this.options?.source || 'moveCardInlineDialog',
          });
          this.model.board = null;
          this.model.set('idBoard', data.idBoard);
          this.model.set('idList', data.idList);
          return this.model.set('pos', data.pos);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (xhr: any) => {
          const errorMessage = parseXHRError(xhr);
          // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
          const error = getApiError(xhr.status, errorMessage);
          const errorType =
            xhr.responseJSON != null ? xhr.responseJSON.error : undefined;
          Analytics.taskFailed({
            taskName: 'edit-card/idBoard',
            // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
            source: this.options?.source || 'moveCardInlineDialog',
            traceId,
            error,
          });
          sendNetworkErrorEvent({
            status: xhr.status,
            response: error.toString,
            url: `/1/cards/${this.model.id}`,
          });

          this.model.getList().cardList.add(this.model);
          if (errorType === tooManyCustomFieldsError) {
            return Alerts.show(
              'too many custom fields card',
              'error',
              'moveerror',
              8000,
            );
          } else if (errorType === tooManyCustomFieldOptionsError) {
            return Alerts.show(
              'too many custom options card',
              'error',
              'moveerror',
              8000,
            );
          } else {
            return Alerts.show(
              'could not move card',
              'error',
              'moveerror',
              5000,
            );
          }
        },
      });
    } else if (traceId) {
      Analytics.taskFailed({
        taskName: 'edit-card/idBoard',
        // @ts-expect-error TS(2339): Property 'source' does not exist on type '{}'.
        source: this.options?.source || 'moveCardInlineDialog',
        traceId,
        error: new Error(
          'card move must have board, list, and position selected',
        ),
      });

      return Alerts.show('could not move card', 'error', 'moveerror', 5000);
    }

    this.onCommit();

    PopOver.hide();
  }

  renderValues() {
    SelectCardPosition.renderValues.call(this);
  }
  updateBoardData() {
    SelectCardPosition.updateBoardData.call(this);
  }
  updatePositionList() {
    SelectCardPosition.updatePositionList.call(this);
  }
}
CardMoveView.initClass();

export { CardMoveView };
